export class Time {
  constructor(time = '0:0') {
    this.value = time;
  }

  get minute() {
    return parseInt(this.value.split(':')[1] || 0);
  }

  set minute(val) {
    let m = parseInt(val);
    if (m >= 60) {
      m = 0;
    } else if (m <= -1) {
      m = 55;
    }
    this.value = `${this.hour}:${m}`;
  }

  get hour() {
    return parseInt(this.value.split(':')[0] || 0);
  }

  set hour(val) {
    let h = parseInt(val);
    if (h >= 24) {
      h = 0;
    } else if (h <= -1) {
      h = 23;
    }
    this.value = `${h}:${this.minute}`;
  }

  get hour_format() {
    return Time.format(this.hour);
  }

  get minute_format() {
    return Time.format(this.minute);
  }

  static format(val) {
    return `${val}`.padStart(2, '0');
  }

  toString() {
    return `${this.hour_format}` + ':' + `${this.minute_format}` + ':' + '00';
  }
}
